import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MODULES } from 'src/app/@core/data/constants';

@Component({
    selector: 'app-permission-form',
    templateUrl: './permission-form.component.html',
    styleUrls: ['./permission-form.component.scss'],
})
export class PermissionFormComponent implements OnInit {
    form: FormGroup;
    @Output('formSubmit') formSubmit: EventEmitter<any> = new EventEmitter();
    submitted: boolean = false;

    modulesGrouped: any;
    resources = ['view', 'create', 'delete'];

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.modulesGrouped = this.resources.reduce(
            (acc, cur) => (acc = { [cur]: JSON.parse(JSON.stringify(MODULES)), ...acc }),
            {}
        );
        this.form = this.formBuilder.group({
            role: new FormControl('', Validators.required),
            permissions: new FormControl({
                view: [],
                create: [],
                delete: [],
            }),
        });
    }

    get controls() {
        return this.form.controls;
    }

    toggle(checked, permission, moduleName) {
        // //console.log(`%c Checked?: ${checked}`, 'background:salmon;color:#111;');

        const selectedPermissions = this.form.get('permissions').value[permission];
        // //console.log(`%c Permissões selecionadas:`, 'background:salmon;color:#111;');
        // //console.log(selectedPermissions);
        const newPermission = moduleName === 'all' ? '*' : moduleName;

        // //console.log(`%c Nova permissão: ${newPermission}`, 'background:salmon;color:#111;');
        if (newPermission === '*') {
            this.toggleAllFromPermission(permission, checked);
            return;
        }

        if (checked) {
            this.form.controls.permissions.patchValue(
                {
                    [permission]: [newPermission, ...selectedPermissions],
                },
                { onlySelf: true }
            );
        } else {
            this.form.controls.permissions.patchValue(
                {
                    [permission]: selectedPermissions.slice(
                        selectedPermissions.indexOf(newPermission),
                        selectedPermissions.length
                    ),
                },
                { onlySelf: true }
            );
        }
    }

    private toggleAllFromPermission(permission: any, checked) {
        // //console.log(`%c modules grouped:`, 'background:salmon;color:#111;');
        // //console.log(this.modulesGrouped);
        // //console.log(`%c module group: ${permission}`, 'background:salmon;color:#111;');
        // //console.log('putaaa que pariu');
        // //console.log(this.form.value);
        this.modulesGrouped[permission].forEach((m) => (m.checked = checked));
        const permissions = checked
            ? this.modulesGrouped[permission].reduce((acc, cur) => [`${cur.key}`, ...acc], [])
            : [];
        this.form.controls.permissions.patchValue({
            ...this.form.controls.permissions.value,
            [permission]: permissions,
        });
    }

    clearForm() {
        this.form.reset();
    }

    emitValues() {
        this.submitted = true;
        if (this.form.invalid) return;
        this.formSubmit.emit(this.form.value);
    }
}
